import { render, staticRenderFns } from "./PanelDashboardDetailDialog.vue?vue&type=template&id=81917616&scoped=true"
import script from "./PanelDashboardDetailDialog.vue?vue&type=script&lang=ts"
export * from "./PanelDashboardDetailDialog.vue?vue&type=script&lang=ts"
import style0 from "./PanelDashboardDetailDialog.vue?vue&type=style&index=0&id=81917616&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81917616",
  null
  
)

export default component.exports